import React, { Component } from "react";
import "../styles/contact.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      message: "",
      success: "",
      error: "",
      disabled: false,
      buttonClass: "contact_button",
      loading: false,
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  onChange (event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  onSubmit (e) {
    e.preventDefault();
    if (this.state.name.length < 3 || this.state.email.length < 3 || this.state.message.length < 3) {
      this.setState({
        error: "Please ensure all fields are filled out",
      });
    } else {
      this.setState({
        error: "",
        disabled: true,
        buttonClass: "contact_button-disabled",
        loading: true,
      });

      const post = {
        name: this.state.name,
        email: this.state.email,
        message: this.state.message,
      };
      fetch("https://db-email-server.herokuapp.com/api/email", {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(post)
      })
        .then(res => (res.status < 400 ? res : Promise.reject(res)))
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            this.setState({
              error: "",
              success: "Email sent successfully",
              disabled: false,
              buttonClass: "contact_button",
              loading: false,
            });
          } else {
            this.setState({
              error: "Error sending message",
              success: "",
              disabled: false,
              buttonClass: "contact_button",
              loading: false,
            });
          }
        });
    }
  }

  render () {
    return (
      <div className="contact-container">
        <h1 className="contact-title">Get In Touch!</h1>
        <form className="signup-form" onSubmit={this.onSubmit}>
          <div className="input-container">
            <input type="name" id="name" name="name" className="contact-input" placeholder="Enter your name..."
              onChange={this.onChange}
              value={this.state.name}
            />

          </div>
          <div className="input-container">
            <input
              type="email" id="email" name="email" className="contact-input" placeholder="Enter your email..."
              onChange={this.onChange}
              value={this.state.email}
            />
          </div>
          <div className="input-container">
            <textarea
              id="message" name="message" className="contact-input msg" placeholder="Enter message..."
              onChange={this.onChange}
              value={this.state.message}
            />
          </div>
          <button
            className={this.state.buttonClass}
            type="submit"
            disabled={this.state.disabled}
          >Submit</button>
          <div className="messages-container">
            {this.state.loading && <Loader
              type="Bars"
              color="#00BFFF"
              height={20}
              width={20}
              timeout={0} 

            />}
            {this.state.error.length > 0 && <div className="error">{this.state.error}</div>}
            {this.state.success.length > 0 && <div className="success">{this.state.success}</div>}
          </div>
        </form>
      </div>
    );
  }
}

export default Contact;
